import classNames from "classnames";
import React, { ComponentPropsWithoutRef, HTMLAttributes } from "react";

const ChipStyles = {
  base: "whitespace-nowrap rounded-lg px-2 py-1 text-sm flex items-center",
  variant: {
    primary: "bg-primary-50 text-neutral-950",
    secondary: "bg-neutral-100 text-neutral-900",
  },
} as const;

// Generic type to generate HTML props based on its tag
type ValidTag = keyof JSX.IntrinsicElements;

type Tag<T extends ValidTag> = {
  as?: T | ValidTag;
} & (ComponentPropsWithoutRef<T> & HTMLAttributes<HTMLOrSVGElement>);

type ChipProps<T extends ValidTag> = Tag<T> & {
  variant: keyof (typeof ChipStyles)["variant"];
};

const DEFAULT_TAG = "span" as const;

export function Chip<T extends ValidTag = typeof DEFAULT_TAG>({
  as: tag = DEFAULT_TAG,
  className,
  variant = "primary",
  ...props
}: ChipProps<T>): JSX.Element {
  const Tag: ValidTag = tag;
  const styles = classNames(
    ChipStyles.base,
    ChipStyles.variant[variant],
    className
  );

  return <Tag {...props} className={styles} />;
}
